module.exports = __webpack_public_path__ + "a8c4d026ab0c39ffe5bb5383c66719b8.pdf";